// The scenario page's follow-ups for the broker, shown above the Ask Addy composer. The page owns
// them: the tray posts every change back to it, and the page checks the scenario again.
export const SCENARIO_QUESTIONS_MESSAGE_KEY = "scenario-questions";

const isRecord = (value) => typeof value === "object" && value !== null;

const readProgress = (value) => {
  if (!isRecord(value) || typeof value.step !== "number") {
    return null;
  }

  const drafts = isRecord(value.drafts)
    ? Object.fromEntries(Object.entries(value.drafts).filter(([, draft]) => typeof draft === "string"))
    : {};

  return { step: Math.max(0, Math.floor(value.step)), drafts, isCollapsed: value.isCollapsed === true };
};

// Only the answers of the follow-ups listed, and only text.
const readOptions = (value, questions) => {
  if (!isRecord(value)) {
    return {};
  }

  return Object.fromEntries(
    questions
      .filter((question) => Array.isArray(value[question]))
      .map((question) => [question, value[question].filter((option) => typeof option === "string" && option.trim())])
      .filter(([, options]) => options.length > 0),
  );
};

const readShared = (value) => {
  if (!isRecord(value) || typeof value.scenarioId !== "string" || !Array.isArray(value.questions)) {
    return null;
  }

  const progress = readProgress(value.progress);
  if (!progress) {
    return null;
  }

  const questions = value.questions.filter((question) => typeof question === "string" && question.trim());

  return {
    scenarioId: value.scenarioId,
    questions,
    options: readOptions(value.options, questions),
    progress,
    progressSource: value.progressSource === "sidebar" ? "sidebar" : "page",
    isBusy: value.isBusy === true,
    dismissingQuestion: typeof value.dismissingQuestion === "string" ? value.dismissingQuestion : null,
  };
};

// Null (the page took them away, or sent something else) hides the tray.
export const readScenarioQuestions = (value, origin, hostWindow = window.parent) => {
  const shared = readShared(value);
  if (!shared || !origin || !hostWindow || hostWindow === window) {
    return null;
  }

  return {
    shared,
    send: (action) => hostWindow.postMessage({ key: SCENARIO_QUESTIONS_MESSAGE_KEY, value: action }, origin),
  };
};
